<template>
    <div>
        <div class="login-container">
            <div v-if="loginDisplay">
                <h2 class="title">Login</h2>
                <p class="subtitle">Fill in details and login to your account!</p>
            </div>
            <div v-if="signUpButtonShow">
                <h2 class="title">New User</h2>
                <p class="subtitle">Fill in details and create a new account!</p>
            </div>
            <div v-if="signedUpSuccess ">
                <h2 class="title mg-btt-15">You have signed up by Email!</h2>
                <p class="subtitle">
			We have sent an email to help you log in. We assigned you a username and portrait that you can change after logging in.
                </p>
                <div class="user-wrap">
                    <div class="portrait-container">
                        <img v-if="loggedInUserInfo.portrait" :src="loggedInUserInfo.portrait">
                        <p v-else class="initial">{{ loggedInUserInfo.username.charAt(0).toUpperCase() }}</p>
                    </div>
                    <p class="login-container__username">{{ loggedInUserInfo.username }}</p>
                </div>
            </div>
            <div v-if="loginSuccess">
                <h2 class="title mg-btt-15">Email on the way</h2>
                <p class="subtitle">
			An email with a login link will be in your inbox shortly.
                </p>
                <div class="user-wrap">
                    <p class="subtitle">Welcome back!</p>
                    <div class="portrait-container">
                        <!-- <img v-if="currentUser?.portrait" :src="currentUser.portrait"> -->
                        <img v-if="loggedInUserInfo.portrait" :src="loggedInUserInfo.portrait">
                        <p v-else class="initial">{{ loggedInUserInfo.username.charAt(0).toUpperCase() }}</p>
                    </div>
                    <p class="login-container__username">{{ loggedInUserInfo.username }}</p>
                </div>
            </div>
            <form v-if="loginDisplay || signUpButtonShow" action="#" @submit.prevent="loginOrCreateAccount">
                <!-- <input type="hidden" name="remember" value="true"/> -->
                <div>
                    <label class="form-group-label" for="email-address">Email address</label>
                    <input
                        id="email-address"
                        v-model="emailInput"
                        placeholder="realeamil@gamo.com"
                        name="email"
                        type="email"
                        autocomplete="off"
                        required
                        ref="emailInput"
                        class="form-group-input" />
                </div>

                <!-- <div>
                    <input id="remember-me" name="remember-me" type="checkbox" />
                    <label for="remember-me">Remember me</label>
                </div> -->

                <div v-if="signUpButtonShow">
                    <VButton
                        type="submit"
                        class="login-btn"
                        @clickHandler="loginOrCreateAccount"
                        :disabled="buttonDisabled"
                    >Create</VButton>

                     <!-- <p class="flex-center">Or</p> -->

                    <!-- <VButton
                        type="submit"
                        class="login-with-sm"
                        :disabled="buttonDisabled"
                        fullWidth="true"
                    >
                        <img src="../assets/images/google-icon.svg" alt="">
                        <span>Continue with Google</span>
                    </VButton>

                    <VButton
                        type="submit"
                        class="login-with-sm"
                        fullWidth="true"
                        :disabled="buttonDisabled"
                    >
                        <img src="../assets/images/github-icon.svg" alt="">
                        <span>Continue with GitHub</span>
                    </VButton> -->

                    <p class="show-create-account">Already have an account? <a class="sing-up-btn" href="#" @click.prevent="showLoginAccount">Log in</a></p>
                </div>
                <div v-if="loginDisplay">
                    <VButton type="submit" class="login-btn" @clickHandler="loginOrCreateAccount" :disabled="buttonDisabled">Login</VButton>
                    <p class="show-create-account">Don't have an account? <a class="sing-up-btn" href="#" @click.prevent="showCreateAccount">Sign up</a></p>
                </div>
            </form>
        </div>
        <Flash ref="show"/>
    </div>
</template>

<script>
import {api} from "@/mixins/axios";
import Flash from "@/components/Flash.vue";
import VButton from "@/components/atoms/VButton.vue";
import {baseURL} from "@/mixins/helpers";

export default {
    name: "Login",
    components: {
        Flash,
        VButton
    },
    data() {
        return {
            emailInput: "",
            loginDisplay: true,
            signUpButtonShow: false,
            signedUpSuccess: false,
            loginSuccess: false,
            createErrorMessage: [],
            errorMessageLogin: [],
            buttonDisabled: false,
            loggedInUserInfo: {
                username: '',
                portrait: ''
            },
            reg: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/,
        };
    },
    methods: {
        // Create account using API
        async loginOrCreateAccount() {
            if (this.buttonDisabled) return
            
            if (!this.reg.test(this.emailInput)) {
                // email validation
                this.$refs.show.showFlashError("Invalid Email Address");
                return null;
            }
            try {
                this.buttonDisabled = true
                const response = await api.post("/user_req_login_email", {
                    email_or_username: this.emailInput,
                });
                if (response?.data.msg === "ok") {
                    this.loginDisplay = false;
                    this.signUpButtonShow = false;

                    if (response?.data?.created) {
                        this.signedUpSuccess = true; // success
                    } else {
                        this.loginSuccess = true;
                    }

                    this.loggedInUserInfo.username = response.data.username

                    this.loggedInUserInfo.portrait = `${baseURL()}${response.data.portrait}`

                    //this.$refs.show.showFlashSuccess("Check your email for a magic link!");

                } else {
                    this.$refs.show.showFlashError(JSON.stringify(result.data.msg));
                }
                this.buttonDisabled = false;
            } catch(err) {
                this.$refs.show.showFlashError(err?.response?.data?.msg);
                this.buttonDisabled = false
            }
        },
        // Create an account show / hide
        showCreateAccount() {
            this.signUpButtonShow = true;
            this.loginDisplay = false;
            this.$refs.emailInput.focus()
        },
        showLoginAccount() {
            this.signUpButtonShow = false;
            this.loginDisplay = true;
            this.$refs.emailInput.focus()
        }
    },
    mounted() {
        if(this.$route.query.mode == 'signup') {
            this.showCreateAccount()
        }
        this.$nextTick(() => this.$refs.emailInput.focus())

        window.addEventListener('storage', e => {
            console.log(e?.storageArea?.token);
            if (e?.storageArea?.token) {
                window.location.reload()
            }
        })
    }
};
</script>
<style scoped lang="scss">

.login-container {
    max-width: 500px;
    margin: 100px auto 0;
    background: var(--primary-bg);
    padding: 40px 50px;
    border-radius: 10px;
    font-weight: 400;

    .title {
        font-size: 30px;
        text-align: left;
        margin-bottom: 3px;
        font-weight: 400;
    }
    .subtitle {
        color: #FFFFFFBF;
        font-size: 18px;
    }

    .form-group-label {
        font-size: 16px;
    }

    .form-group-input {
        display: block;
        width: 100%;
        padding: 10px;
        font-size: 16px;
        border-radius: 7px;
        outline: none;
        background: var(--primary-bg);
        border: 0.5px solid var(--outline);
        color: var(--primary-text);

        &::placeholder {
            color: var(--placeholder);
            font-size: 18.2px;
            font-weight: 300;
        }

        &:focus {
            outline: 0.5px solid var(--outline-active);
        }
    }

    .login-btn {
        display: block;
        width: 100%;
        padding: 11px 10px;
        border: none;
        background: $blue-5;
        color: #FFFFFFE5;
        margin-top: 10px;
        font-size: 18px;
        border-radius: 7px !important;
        cursor: pointer;
        height: auto;

        &:hover {
            background-color: #4E8EF8;
        }
    }

    .flex-center {
        display: flex;
        justify-content: center;
        color: #B6B6B6;
        font-size: 16px;
        font-weight: 400;
        margin: 15px 0;
    }

    .login-with-sm {
        color: rgba(255, 255, 255, 0.90);
        font-size: 18px;
        font-weight: 400;
        border-radius: 7.8px;
        background: #565A5D;
        padding: 11px 10px;
        height: 30px;
        margin-bottom: 15px;
        &:hover {
            background-color: #505b63;
        }
        img {
            margin-right: 5px;
        }
    }

    .show-create-account {
        margin-bottom: 2px;
        margin-top: 20px;
        font-size: 18px;
        
        span {
            color: $purple-0;
            cursor: pointer;
            text-decoration: underline;
            user-select: none;
        }
    }
    .sing-up-btn {
        color: $blue-5;
        font-size: 18px;
    }
    .forgot-psw-btn {
        color: #9BDBFF;
        font-size: 14px;
    }

    .user-wrap {
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 8px;

        .subtitle {
            margin-top: 10px;
            margin-bottom: 0;
        }
    }

    &__username {
        background-color: #9E9E9E33;
        width: fit-content;
        padding: 0 5px;
        border-radius: 5px;
    }

    .portrait-container img {
        width: 84px;
        height: 84px;
        border-radius: 50%;
    }
}
</style>
